var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMidPlanetResponsiveLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 395 128",
    style: {
      enableBackground: "new 0 0 395 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.culture_st0{fill:#F1E8E6;}\n\t.culture_st1{fill:#2F462F;}\n\t.culture_st2{fill:#BFC8B8;}\n\t.culture_st3{fill:#FFFFFF;}\n\t.culture_st4{fill:none;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:10;}\n\t.culture_st5{fill:#586753;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M328.5,66.5h-1.3v7.2h1.3V66.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M315.2,66.5h-1.3v7.2h1.3V66.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st1",
    d: "M304,108.5h22.2V72.9H304V108.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M310.8,108.5H333V72.9h-22.2V108.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st1",
    d: "M330.6,55.5h-21.1v12.9h21.1V55.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st2",
    d: "M332.5,55.5h-21.1v12.9h21.1V55.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M331.2,75.3h-18.5v3h18.5V75.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M331.2,80.3h-18.5v3h18.5V80.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M331.2,85.1h-18.5v3h18.5V85.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M331.2,90.1h-18.5v3h18.5V90.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M331.2,95.1h-18.5v3h18.5V95.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M331.2,100h-18.5v3h18.5V100z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M331.2,104.9h-18.5v3h18.5V104.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M326.1,59.4l-1.1-1.1l-6.5,6.6l1.1,1.1L326.1,59.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M324.9,66l1.1-1.1l-6.5-6.6l-1.1,1.1L324.9,66z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st1",
    d: "M248.3,89c-42.4,0-89.1,4.2-105.7,31.1c-0.8,1.3,0.2,2.8,1.7,2.8h211.7c1.4,0,2.4-1.5,1.7-2.8 C340.1,86.7,291,89,248.3,89z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M362.9,35.9H361v5.8h1.9V35.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M363.1,37.5c6.2,0,11.3-5,11.3-11.2c0-6.2-5-11.2-11.3-11.2c-6.2,0-11.3,5-11.3,11.2S356.9,37.5,363.1,37.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st1",
    d: "M380.7,41.7h-27.2V123h27.2V41.7z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M372.2,41.7H345V123h27.2V41.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st1",
    d: "M360.9,37.5c6.2,0,11.3-5,11.3-11.2c0-6.2-5-11.2-11.3-11.2c-6.2,0-11.3,5-11.3,11.2 C349.7,32.5,354.7,37.5,360.9,37.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M370,80.5h-22.7v3.6H370V80.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M370,86.5h-22.7v3.6H370V86.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M370,92.4h-22.7V96H370V92.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M370,98.4h-22.7v3.6H370V98.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M370,104.5h-22.7v3.6H370V104.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M370,110.6h-22.7v3.6H370V110.6z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M370,116.4h-22.7v3.6H370V116.4z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M370,44.5h-22.7V48H370V44.5z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M370,50.4h-22.7V54H370V50.4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M370,56.4h-22.7V60H370V56.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M370,62.5h-22.7v3.6H370V62.5z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M370,68.6h-22.7v3.6H370V68.6z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M370,74.4h-22.7V78H370V74.4z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M351.4,43.2h-1.7v78.1h1.7V43.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M355.7,43.2H354v78.1h1.7V43.2z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M360.1,43.2h-1.7v78.1h1.7V43.2z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M364.5,43.2h-1.7v78.1h1.7V43.2z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M368.2,43.2h-1.7v78.1h1.7V43.2z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M365.1,22h-8.6v8.6h8.6V22z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st2",
    d: "M362.8,26.2l-2.1-2.1l-2.1,2.1l2.1,2.1L362.8,26.2z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M388,101h-10.3v1.1H388V101z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M388,106.4h-10.3v1.1H388V106.4z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M388,117.7h-10.3v1.1H388V117.7z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M388,73.1l-1.7,16.6l3.2-2.8L388,73.1z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st1",
    d: "M395,86.5h-13.2V123H395V86.5z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st3",
    d: "M389.4,86.5h-13.2V123h13.2V86.5z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M387.9,90.2h-10.3v1.1h10.3V90.2z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M387.9,95.5h-10.3v1.1h10.3V95.5z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M388,112.3h-10.3v1.1H388V112.3z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M387.9,74c0.5,0,1-0.4,1-1c0-0.5-0.4-1-1-1c-0.5,0-1,0.4-1,1C386.9,73.6,387.3,74,387.9,74z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M388,101h-10.3v1.1H388V101z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st0",
    d: "M388,106.4h-10.3v1.1H388V106.4z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st2",
    d: "M176.7,108.9c-4.4-19.7-24.6-34.6-48.9-34.6s-44.6,14.9-48.9,34.6H176.7z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st2",
    d: "M99,125.8c-4.4-22.4-51.2-24.1-75.5-24.1C0,96.3,1,121.4,0,128L99,125.8z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st1",
    d: "M155.4,89.4c4.5,0,8.2-9.6,8.1-21.5c-0.1-11.8-3.8-21.4-8.3-21.4c-4.5,0-8.2,9.6-8.1,21.5 C147.1,79.8,150.9,89.4,155.4,89.4z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st4",
    d: "M155.4,61.4l0.2,50.5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st4",
    d: "M152,69.7l3.6,2"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st4",
    d: "M155.5,76.1l4.2-2.4"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st4",
    d: "M152,78.4l3.6,2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st4",
    d: "M155.4,64.9l4.3-2.5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st4",
    d: "M152,67.1l3.6,2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "culture_st5",
    d: "M201,128c1.7-3.2,1.3-7.1-1.2-9.6c-1.5-1.5-3.3-3-5.2-4.3C172.3,98.6,95,89.2,58,96.3C21,103.4,7.5,115.4,0,128 H201z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidPlanetResponsiveLeft);
export default __webpack_public_path__ + "static/media/mid_planet_responsive-left.517e467272cc5bb4771ca1d577498437.svg";
export { ForwardRef as ReactComponent };